import Swal from 'sweetalert2';

const PaymentActions = ({ payment, onVerify, onReject, onRevert }) => {
  return (
    <div className="flex space-x-2">
      {payment.status === 'pending' && (
        <>
          <button
            onClick={() => onVerify(payment._id)}
            className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-green-600 hover:bg-green-700 focus:outline-none"
          >
            Verify
          </button>
          <button
            onClick={() => onReject(payment._id)}
            className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-red-600 hover:bg-red-700 focus:outline-none"
          >
            Reject
          </button>
        </>
      )}
      {(payment.status === 'verified' || payment.status === 'rejected') && (
        <button
          onClick={() => onRevert(payment)}
          className={`inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded shadow-sm text-white ${
            payment.status === 'verified' ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'
          } focus:outline-none`}
        >
          Revert to {payment.status === 'verified' ? 'Rejected' : 'Verified'}
        </button>
      )}
    </div>
  );
};

export default PaymentActions;